import React from 'react';
import { TextField, Button, Box } from '@mui/material';
interface PinyinInputProps {
  userInput: string;
  setUserInput: React.Dispatch<React.SetStateAction<string>>;
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PinyinInput: React.FC<PinyinInputProps> = ({ userInput, setUserInput, onInputChange }) => {

  const addNumber = (number: string) => {
    setUserInput(userInput + number);
    onInputChange({ target: { value: userInput + number } } as React.ChangeEvent<HTMLInputElement>);
  };
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    }}>
      <TextField
        value={userInput}
        variant="outlined"
        sx={{ width: '100%', marginBottom: 2 }}
      />
      <Box sx={{ marginBottom: 1 }}>
        {['1', '2', '3', '4', '5'].map(number => (
          <Button key={number} variant="contained" sx={{ marginX: 0.5 }} onClick={() => addNumber(number)}>
            {number}
          </Button>
        ))}
      </Box>
      <Button variant="outlined" onClick={() => setUserInput(userInput.slice(0, -1))}>
        １字消す
      </Button>
    </Box>
  );
};

export default PinyinInput;
